export default {
        main_color: "#F88D3F",
        params: {
                params_show_type_list: [
                        { id: 'T', name: '文本' },
                        { id: 'P', name: '图片' },
                ],
                params_assignment_type_list: [
                        { id: 'R', name: '单选' },
                        { id: 'C', name: '多选' },
                        { id: 'V', name: '文本值' },
                ],
                params_status_list: [
                        { id: 'Y', name: '过滤项', add_name: '是' },
                        { id: 'N', name: '非过滤项', add_name: '否' },
                ],
                params_content_status_list: [
                        { id: 1, name: '启用' },
                        { id: 0, name: '禁用' },
                ]
        },
        getAssignmentType(type) {
                let str = '';
                switch (type) {
                        case 'R':
                                str = '单选';
                                break;
                        case 'C':
                                str = '多选';
                                break;
                        case 'V':
                                str = '文本值';
                                break;
                        default:
                                break;
                }
                return str;
        },
        form_search_style: {
                backgroundColor: '#F7F8FA',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                padding: '26px 65px 16px 65px'
        },
        // 2--官方旗舰店 1--旗舰店 0--普通店铺   3- 企业供应商  4-个人供应商 5-个体工商户供应商
        supplier_type: {
                2: '官方旗舰店',
                1: '旗舰店',
                0: '普通店铺',
                3: '企业供应商',
                4: '个人供应商',
                5: '个体工商户供应商',
        },
        rake_list: ['0.01', '0.02', '0.03', '0.04', '0.05', '0.06', '0.07', '0.08', '0.09', '0.1'],
        // 1-企业 2- 个体工商户 3- 小微（个人）
        new_store_type: [
                { id: 1, name: '企业' },
                { id: 2, name: '个体工商户' },
                { id: 3, name: '小微（个人）' },
        ],
        header_cell_style:{
                textAlign: "center",
                backgroundColor: "#F7F8FA",
                height: "60px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#333333",
        },
        invoice_method: [
                { id: 1, name: '供应商->客户' }, { id: 2, name: '平台服务费发票' }, { id: 3, name: '供应商->平台' }
        ],
        invoice_type: [{ id: 1, name: '增值税初普通发票' }, { id: 2, name: '增值税专用发票' }],
        invoice_title_type: [{ id: 0, name: '个人/事业单位' }, { id: 1, name: '企业单位' }],
        invoice_status: [{ id: 0, name: '待提交' }, { id: -1, name: '开票失败' }, { id: 1, name: '开票中' }, { id: 2, name: '开票成功' }],
        repair_acceptance_scope: [{ id: 5, name: '5公里内' },
        { id: 10, name: '10公里内' },
        { id: 30, name: '30公里内' },
        { id: 50, name: '50公里内' },
        { id: 0, name: '均可' },],
        app_type_list:[{id:1,name:'淘叉街'},{id:2,name:'淘叉街商家版'}]
}